import { z } from 'zod';

import { zodCreatedListResponseSchema } from '../../validations';

/** A row of the file that left an existing site alone. */
const zodSkippedSiteCsvRowSchema = z.object({
  /** Spreadsheet line of the row, the header is line 1. */
  line: z.number().int(),
  reason: z.enum([
    'existing_site',
    'synced_site',
    'other_company',
    'other_site_type',
    'unchanged',
  ]),
  siteId: z.uuid(),
});

/**
 * `ids` holds the written sites. `total`, `created`, `updated`, `skipped` and
 * `failed` are only sent by API versions that update existing sites by
 * `sync_key`.
 */
export const zodCreateSitesAndCostCentersViaCSVResponseSchema =
  zodCreatedListResponseSchema.extend({
    created: z.number().int().optional(),
    failed: z.number().int().optional(),
    skipped: z.array(zodSkippedSiteCsvRowSchema).optional(),
    total: z.number().int().optional(),
    updated: z.number().int().optional(),
  });
